// extracted by mini-css-extract-plugin
export var avatarContainer = "_redotech-arbiter-lib-avatars-avatar-avatar-container";
export var largeAvatarContainer = "_redotech-arbiter-lib-avatars-avatar-large-avatar-container";
export var smallAvatarContainer = "_redotech-arbiter-lib-avatars-avatar-small-avatar-container";